import { formatValue } from "@/features/forms/_logic/field-utils";
import type { FormSummaryEntry } from "@/features/landing-page-v2/_components/public/CheckoutStep";
import type { FormField } from "@/lib/database/forms";

/**
 * Builds the answer summary shown on the landing page checkout step. Each answer is formatted
 * with the same {@link formatValue} the responses table uses, so an "other" answer, a multiselect,
 * a phone number and a signature read as text instead of `[object Object]`.
 *
 * @param visibleFields - The form's fields currently visible to the respondent, in form order
 * @param formData - The respondent's answers keyed by field label
 * @returns One entry per answered question, skipping sections, descriptions and answers that format to nothing
 * @throws Never.
 */
export function buildFormSummary(visibleFields: FormField[], formData: Record<string, unknown>): FormSummaryEntry[] {
  const summary: FormSummaryEntry[] = [];
  for (const field of visibleFields) {
    if (field.type === "section" || field.type === "description") continue;
    const raw = formData[field.label];
    if (!raw) continue;
    const value = formatValue(raw, field);
    if (!value) continue;
    summary.push({ label: field.label, value });
  }
  return summary;
}
